@if (seller) {
  @if (languageChange$ | async; as _lang) {
    <!-- begin:: container -->
    <ng-container *transloco="let t">
      <div class="container my-4 d-flex align-items-center justify-content-space-between rounded py-5 px-5 bg-light-warning">
        <!--begin::Logo-->
        <span class="symbol-label">
          <img class="h-20px h-md-30px align-self-center me-5" src="https://www.bildelsbasen.se/static/images/logo/company/{{ seller?.id }}.png" [alt]="(seller?.name)" />
        </span>
        <!--end::Logo-->
        <!-- begin:: seller name -->
        <div class="text-gray-700 fw-bold fs-8 fs-md-6 seller-name" transloco="dynamic_seller_own_stock_banner" [translocoParams]="{ value: (seller?.name) }"></div>
        <!-- end:: seller name -->
        <!-- begin:: back to parent group -->
        <button type="button" (click)="onExitOwnStock()" title="Exit {{ seller?.name }} Stock" class="btn bnt-icon btn-sm">
          <i class="bi bi-x-circle fs-1"></i>
        </button>
        <!-- end:: back to parent group -->
      </div>
    </ng-container>
    <!-- end:: container -->
  }
}
